import { find, includes, map } from 'lodash';
import { PhoneActions } from './PhoneActions';

const defaultState = {
    phoneNumber: null,
    phoneNumberFormatted: '',
    fetchingServiceTypes: false,
    fetchServiceTypesFailure: false,
    allowText: false,
    allowCall: false,
};

export const phoneReducer = (state = defaultState, action) => {
    switch (action.type) {
        case PhoneActions.FETCHING_SERVICE_TYPES: {
            return {
                ...state,
                fetchingServiceTypes: true,
            };
        }

        case PhoneActions.FETCH_SERVICE_TYPES_SUCCESS: {
            const serviceNames = map(
                action.phoneData.available_services,
                (service) => service.name
            );
            return {
                ...state,
                fetchingServiceTypes: false,
                phoneData: action.phoneData,
                phoneNumber: find(
                    action.phoneData.phone_numbers,
                    (entry) => entry.type === 'cell'
                ).display_phone_number,
                allowText: includes(serviceNames, 'Sms'),
                allowCall: includes(serviceNames, 'Phone'),
            };
        }

        case PhoneActions.FETCH_SERVICE_TYPES_FAILURE: {
            return {
                ...state,
                fetchingServiceTypes: false,
                fetchServiceTypesFailure: true,
            };
        }
        default:
            return state;
    }
};
